var _defs, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 37.49 34.17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M36.63,13.9l-6.19-10.73c-1.14-1.97-3.24-3.18-5.51-3.18h-12.38c-2.27,0-4.37,1.21-5.51,3.18L.85,13.9c-1.14,1.97-1.14,4.39,0,6.36l6.19,10.73c1.14,1.97,3.24,3.18,5.51,3.18h12.38c2.27,0,4.37-1.21,5.51-3.18l6.19-10.73c1.14-1.97,1.14-4.39,0-6.36ZM31.54,22.26c0,4.19-3.26,7.46-7.44,7.47-1.78,0-3.55,0-5.33,0-1.78,0-3.55,0-5.33,0-3.57-.01-6.52-2.37-7.28-5.85-.11-.52-.16-1.05-.16-1.58-.01-3.56,0-7.13,0-10.69,0-4.16,3.25-7.42,7.41-7.44,3.57-.01,7.15-.01,10.72,0,4.19.02,7.42,3.28,7.42,7.48,0,3.54,0,7.07,0,10.61Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.17,17.01c0,1.9.06,3.8-.01,5.7-.1,2.72-2.23,4.71-4.95,4.71-3.63,0-7.26,0-10.89,0-2.83,0-4.98-2.16-4.98-4.98,0-3.61,0-7.22,0-10.83,0-2.86,2.14-5.01,5.01-5.01,3.6,0,7.2,0,10.8,0,2.88,0,5,2.12,5.02,5.01.01,1.81,0,3.61,0,5.42h-.01ZM12.12,17.01c0,3.67,2.99,6.64,6.65,6.63,3.7-.01,6.63-2.98,6.62-6.71,0-3.62-3-6.56-6.66-6.56-3.65,0-6.62,2.99-6.61,6.63ZM25.6,11.68c.85,0,1.54-.67,1.55-1.52,0-.86-.68-1.57-1.54-1.57-.85,0-1.54.68-1.55,1.53-.01.86.68,1.56,1.54,1.57Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.47,17c0-2.38,1.95-4.31,4.31-4.29,2.37.02,4.27,1.94,4.27,4.3,0,2.38-1.94,4.29-4.34,4.28-2.34,0-4.24-1.94-4.24-4.3Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/Instagram.909d6878c8c3f42d1245887f8e1608dc.svg";
export { ForwardRef as ReactComponent };